module.exports = __webpack_public_path__ + "img/13.3f0da3ee.jpg";